import ExperienceYearsPages from './subPages/experienceYears';
import ContractTypesPages from './subPages/contractTypes';
import VacancyCategoriesPages from './subPages/vacancyCategories';
import CandidatesPages from './subPages/candidates';
import VacanciesPages from './subPages/vacancies';
import VacancyApplicationsPages from './subPages/vacancy_applications';
import CandidatesAutoPages from './subPages/auto';
import UserVacanciesPages from './subPages/user_vacancies';
import VacancyApplicationTypesPages from './subPages/vacancy_application_types';
import VacancyLanguagesPages from './subPages/vacancyLanguages';
import VacancyLogs from './subPages/logs';

const routes = [
  {
    path: '/experience_years/*',
    canUse: [],
    Component: ExperienceYearsPages,
  },
  {
    path: '/contract_types/*',
    canUse: [],
    Component: ContractTypesPages,
  },
  {
    path: '/vacancy_languages/*',
    canUse: [],
    Component: VacancyLanguagesPages,
  },
  {
    path: '/vacancy_categories/*',
    canUse: [],
    Component: VacancyCategoriesPages,
  },
  {
    path: '/candidates/*',
    canUse: [],
    Component: CandidatesPages,
  },
  {
    path: '/vacancies/*',
    canUse: [],
    Component: VacanciesPages,
  },
  {
    path: '/vacancy_applications/*',
    canUse: [],
    Component: VacancyApplicationsPages,
  },
  {
    path: '/auto/*',
    canUse: [],
    Component: CandidatesAutoPages,
  },
  {
    path: '/user_vacancies/*',
    canUse: [],
    Component: UserVacanciesPages,
  },
  {
    path: '/vacancy_application_types/*',
    canUse: [],
    Component: VacancyApplicationTypesPages,
  },
  {
    path: '/customer_logs/*',
    canUse: [],
    Component: VacancyLogs,
  },
];

export default routes;
